export const Environment = window.env.environment;

export const AssetsUrl =
  Environment === "prod" ? "https://assets.manvfat.com" : `https://${Environment}-assets.manvfat.com`;

export const ImagesUrl = `${AssetsUrl}/images`;

export const PdfsUrl = `${AssetsUrl}/pdfs`;

export const FontsUrl = `${AssetsUrl}/fonts`;
